var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 500,
    viewBox: "0 0 1600 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1190 120-250-20L1600 0v500L440 350l250-20L0 250l1190-130z",
    fill: "#1B3A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavage);
export default __webpack_public_path__ + "static/media/savage.a977988c1a5e58fae0ffee193536f1bc.svg";
export { ForwardRef as ReactComponent };